import { TApplicationState } from 'shared/types/redux';

export const selectPrediction = (state: TApplicationState): boolean => {
  return state.predictionState.visible;
};
